import { useEffect, useRef, useState } from 'react'

// Hook that calculates the number of th elements in a table using a ref
// Returns an object containing the ref to attach to the table and the column count
export const useColumnCount = () => {
  const tableRef = useRef<HTMLTableElement>(null)
  const [columnCount, setColumnCount] = useState<number>(0)

  useEffect(() => {
    const calculateColumnCount = () => {
      if (tableRef.current) {
        // Find the first thead or tr element to count th elements
        const thead = tableRef.current.querySelector('thead')
        const firstRow =
          thead?.querySelector('tr') || tableRef.current.querySelector('tr')

        if (firstRow) {
          const thElements = firstRow.querySelectorAll('th')
          setColumnCount(thElements.length)
        } else {
          setColumnCount(0)
        }
      }
    }

    // Calculate initially
    calculateColumnCount()
  }, [])

  return {
    tableRef,
    columnCount
  }
}
